/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CorporateStructureLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The CorporateStructureLink model module.
   * @module model/CorporateStructureLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CorporateStructureLink</code>.
   * @alias module:model/CorporateStructureLink
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>CorporateStructureLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CorporateStructureLink} obj Optional instance to populate.
   * @return {module:model/CorporateStructureLink} The populated <code>CorporateStructureLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ProductID')) {
        obj['ProductID'] = ApiClient.convertToType(data['ProductID'], 'Integer');
      }
      if (data.hasOwnProperty('GeoAreaID')) {
        obj['GeoAreaID'] = ApiClient.convertToType(data['GeoAreaID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomerID')) {
        obj['CustomerID'] = ApiClient.convertToType(data['CustomerID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevel1ItemID')) {
        obj['TrackingLevel1ItemID'] = ApiClient.convertToType(data['TrackingLevel1ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevel2ItemID')) {
        obj['TrackingLevel2ItemID'] = ApiClient.convertToType(data['TrackingLevel2ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevel3ItemID')) {
        obj['TrackingLevel3ItemID'] = ApiClient.convertToType(data['TrackingLevel3ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevel4ItemID')) {
        obj['TrackingLevel4ItemID'] = ApiClient.convertToType(data['TrackingLevel4ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ProductID
   */
  exports.prototype['ProductID'] = undefined;
  /**
   * @member {Integer} GeoAreaID
   */
  exports.prototype['GeoAreaID'] = undefined;
  /**
   * @member {Integer} CustomerID
   */
  exports.prototype['CustomerID'] = undefined;
  /**
   * @member {Integer} TrackingLevel1ItemID
   */
  exports.prototype['TrackingLevel1ItemID'] = undefined;
  /**
   * @member {Integer} TrackingLevel2ItemID
   */
  exports.prototype['TrackingLevel2ItemID'] = undefined;
  /**
   * @member {Integer} TrackingLevel3ItemID
   */
  exports.prototype['TrackingLevel3ItemID'] = undefined;
  /**
   * @member {Integer} TrackingLevel4ItemID
   */
  exports.prototype['TrackingLevel4ItemID'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;



  return exports;
}));


